import React, { useState, useRef, useCallback } from "react";
import {
  GoogleMap,
  Autocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";
import { Drawer, Button } from "antd";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setTogglePabiliMap } from "../redux/feature/order";
import { FaMapPin, FaLocationDot } from "react-icons/fa6";
const GOOGLE_MAPS_LIBRARIES = ["places"];

const PabiliMap = ({ setValue, handleFieldChange, setCoordinates }) => {
  const dispatch = useDispatch();
  // const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(true);
  // const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [markerPosition, setMarkerPosition] = useState({
    lat: 17.12406586537637,
    lng: 121.61461579553392,
  });
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  const { togglePabiliMap } = useSelector((state) => state.order);

  const autocompleteRef = useRef(null);
  const mapRef = useRef(null);

  // useEffect(() => {
  //   setMarkerPosition({
  //     lat: orderFormData.customerLatitude,
  //     lng: orderFormData.customerLongitude,
  //   });
  // }, [orderFormData.customerLatitude, orderFormData.customerLongitude]);

  const handleConfirmLocation = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse`,
        {
          params: {
            lat: markerPosition.lat,
            lon: markerPosition.lng,
            format: "json",
          },
        }
      );

      const { data } = await axios.get(
        `https://api.dorydelivery.com/api/utility/get-province-city?latitude=${markerPosition.lat}&longitude=${markerPosition.lng}`
      );

      setCoordinates({
        latitude: markerPosition.lat,
        longitude: markerPosition.lng,
      });
      setValue("city", data.result.city);
      setValue("province", data.result.province);
      setValue("customerLatitude", markerPosition.lat);
      setValue("customerLongitude", markerPosition.lng);
      setValue("address", response.data.display_name);

      if (data.result.city && data.result.province) {
        handleFieldChange("province");
        handleFieldChange("city");
      }

      // const pabiliDetails = {
      //   pickupLocation: {
      //     locationText: `${response.data.name} ${data.result.city}, ${data.result.province}`,
      //     coordinates: {
      //       latitude: markerPosition.lat,
      //       longitude: markerPosition.lng,
      //     },
      //   },
      //   dropOffLocation: {
      //     locationText: orderFormData.address,
      //     coordinates: {
      //       latitude: orderFormData.customerLatitude,
      //       longitude: orderFormData.customerLongitude,
      //     },
      //   },
      //   pickUpLocationRiderToCheck: {
      //     province: data.result.province,
      //     city: data.result.city,
      //   },
      // };

      // dispatch(setPabiliDetails(pabiliDetails));
      setLoading(false);
      dispatch(setTogglePabiliMap(false));
    } catch (error) {
      setLoading(false);
      console.log(">>> SOmething went wrong geocoding the place");
    }
  };

  const handlePlaceSelected = () => {
    const place = autocompleteRef.current.getPlace();
    if (place.geometry) {
      const { lat, lng } = place.geometry.location;
      const newCoords = { lat: lat(), lng: lng() };

      setMarkerPosition(newCoords);

      mapRef.current.panTo(newCoords);
    }
  };

  // const handleMarkerDragEnd = (event) => {
  //   const newCoords = {
  //     lat: event.latLng.lat(),
  //     lng: event.latLng.lng(),
  //   };

  //   setMarkerPosition(newCoords);
  // };

  const close = () => {
    dispatch(setTogglePabiliMap(false));
  };

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleCenterChanged = useCallback(() => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter();
      const newLatLng = { lat: newCenter.lat(), lng: newCenter.lng() };

      // Only update state if the position has actually changed
      if (
        newLatLng.lat !== markerPosition.lat ||
        newLatLng.lng !== markerPosition.lng
      ) {
        setMarkerPosition(newLatLng);
      }
    }
    setIsDragging(false);
  }, [markerPosition]);

  if (loadError) return <div>Error loading Google Maps</div>;
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <Drawer
      open={togglePabiliMap}
      onClose={close}
      placement="bottom"
      size="large"
      bodyStyle={{
        padding: 0, // Remove padding to allow full-screen map
        height: "100vh", // Ensure full viewport height
      }}
    >
      <div
        style={{
          position: "relative",
          height: "100vh",
          width: "100vw",
          overflow: "hidden",
        }}
      >
        <GoogleMap
          mapContainerStyle={{
            height: "100%",
            width: "100%",
          }}
          zoom={16}
          options={{
            fullscreenControl: false,
            mapTypeControl: true,
            streetViewControl: false,
            zoomControl: false,
            rotateControl: false,
            gestureHandling: "greedy",
            scaleControl: false,
          }}
          center={markerPosition}
          onLoad={(mapInstance) => (mapRef.current = mapInstance)}
          onDragStart={handleDragStart}
          onIdle={handleCenterChanged}
        >
          {/* <Marker
            position={markerPosition}
            draggable={true}
            onDragEnd={handleMarkerDragEnd}
          /> */}
        </GoogleMap>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -100%)",
            zIndex: 10,
            fontSize: "40px",
            color: "#00BF63",
          }}
        >
          {isDragging ? <FaMapPin /> : <FaLocationDot />}
        </div>

        <div
          style={{
            position: "absolute",
            top: "60px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "90%",
            zIndex: 10,
            backgroundColor: "white",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
            borderRadius: "20px",
          }}
        >
          <Autocomplete
            onLoad={(instance) => (autocompleteRef.current = instance)}
            onPlaceChanged={handlePlaceSelected}
            options={{
              componentRestrictions: { country: "ph" },
              fields: ["name", "geometry.location"],
            }}
          >
            <input
              type="text"
              placeholder="Search for a location"
              style={{
                width: "100%",
                height: "48px",
                padding: "5px 10px",
                fontSize: "16px",
                border: "none",
                outline: "none",
                borderRadius: "20px",
                boxSizing: "border-box",
              }}
            />
          </Autocomplete>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1,
          position: "absolute",
          top: "90%",
          width: "100%",
        }}
      >
        <Button
          type="primary"
          style={{
            zIndex: 10,
            padding: "10px 20px",
            fontSize: "16px",
            width: "90%",
            height: "40px",
            borderRadius: "20px",
            backgroundColor: "#00BF63",
          }}
          onClick={handleConfirmLocation}
          loading={loading}
          disabled={loading}
        >
          Confirm Location
        </Button>
      </div>
    </Drawer>
  );
};

export default PabiliMap;
